// Centraliserad API-klient
// Hämtar automatiskt JWT från localStorage och hanterar fel

const API_URL = process.env.REACT_APP_API_URL || '/api';

const getToken = () => localStorage.getItem('token');

const request = async (method, path, body = null) => {
  const headers = { 'Content-Type': 'application/json' };
  const token = getToken();
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const config = { method, headers };
  if (body) config.body = JSON.stringify(body);

  const res = await fetch(`${API_URL}${path}`, config);
  const data = await res.json();

  if (!res.ok) {
    // Om 401, rensa token och ladda om sidan
    if (res.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    throw new Error(data.error || 'Något gick fel');
  }
  return data;
};

export const api = {
  get: (path) => request('GET', path),
  post: (path, body) => request('POST', path, body),
  put: (path, body) => request('PUT', path, body),
  delete: (path) => request('DELETE', path),

  // Auth
  register: (data) => request('POST', '/auth/register', data),
  requestOTP: (email) => request('POST', '/auth/request-otp', { email }),
  verifyOTP: (email, code) => request('POST', '/auth/verify-otp', { email, code }),
  getMe: () => request('GET', '/auth/me'),

  // Company
  getCompany: () => request('GET', '/company'),
  updateCompany: (data) => request('PUT', '/company', data),

  // Users
  getUsers: () => request('GET', '/users'),
  inviteUser: (email) => request('POST', '/users/invite', { email }),
  removeUser: (id) => request('DELETE', `/users/${id}`),
  updateUserRole: (id, role) => request('PUT', `/users/${id}/role`, { role }),
  cancelInvitation: (email) => request('DELETE', `/users/invitations/${encodeURIComponent(email)}`),
  updateMyProfile: (name) => request('PUT', '/users/me', { name }),

  // Customers
  getCustomers: () => request('GET', '/customers'),
  getCustomer: (id) => request('GET', `/customers/${id}`),
  createCustomer: (data) => request('POST', '/customers', data),
  updateCustomer: (id, data) => request('PUT', `/customers/${id}`, data),
  deleteCustomer: (id) => request('DELETE', `/customers/${id}`),

  // Quotes
  getQuotes: () => request('GET', '/quotes'),
  getQuote: (id) => request('GET', `/quotes/${id}`),
  createQuote: (data) => request('POST', '/quotes', data),
  updateQuote: (id, data) => request('PUT', `/quotes/${id}`, data),
  updateQuoteStatus: (id, status) => request('PATCH', `/quotes/${id}/status`, { status }),
  sendQuoteToPortal: (quote_id) => request('POST', '/portal/send', { quote_id }),
  deleteQuote: (id) => request('DELETE', `/quotes/${id}`),

  // AI
  generateDescription: (notes) => request('POST', '/ai/generate-description', { notes }),
};
